<!-- Місце читається як один із пунктів шапки, а не як окремий значок поруч:
     той самий підпис, той самий рядок зі значенням і рядок дії під ним. Раніше
     тут була смуга заповнення замість третього рядка — саме через неї пункт
     виглядав чужим серед трьох однакових. -->
<div *ngIf="show"
     class="headerMenuItem storageItem"
     [class.warn]="warn"
     [class.over]="over"
     [nbPopover]="storagePopover"
     nbPopoverTrigger="hover"
     nbPopoverPlacement="bottom">

	<div class="lbl"><span>Квота</span></div>

	<div class="middle">
		<div class="menuItemIcon"><nb-icon icon="hard-drive-outline"></nb-icon></div>
		<div class="menuItemText">{{usedValue}} {{usedInTb ? 'ТБ' : 'ГБ'}}<span *ngIf="hasQuota"> / {{quotaValue}} {{quotaInTb ? 'ТБ' : 'ГБ'}}</span></div>
	</div>

	<div class="bottom">
		<a *ngIf="priceAmount" href="javascript:;" (click)="buy(); $event.stopPropagation()">
			<span class="txt">{{buying ? 'Додаємо...' : 'Додати 1 ТБ'}}</span>
			<span class="mobicon"><nb-icon class="caret" icon="plus-square-outline"></nb-icon></span>
		</a>
		<!-- Продавати нічого: рядок усе одно каже, звідки це місце, щоб пункт мав
		     ті самі три рядки, що й сусідні. -->
		<span *ngIf="!priceAmount && s?.tariffTitle">Тариф {{s.tariffTitle}}</span>
	</div>
</div>

<ng-template #storagePopover>
	<div class="storageTooltip">
		<div class="stTitle" *ngIf="over">Квоту тарифу перевищено</div>
		<div class="stTitle" *ngIf="warn && !over">Квота майже вичерпана</div>
		<div class="stTitle" *ngIf="!over && !warn">Квота сховища</div>

		<div class="stRow">
			Використано <b>{{usedValue}} {{usedInTb ? 'ТБ' : 'ГБ'}}</b><span *ngIf="hasQuota"> із <b>{{quotaValue}} {{quotaInTb ? 'ТБ' : 'ГБ'}}</b><span *ngIf="s.tariffTitle">, які включає тариф {{s.tariffTitle}}</span></span><span *ngIf="s.addonTb"> (зокрема {{s.addonTb}} ТБ, які ви додали)</span>.
		</div>

		<!-- Смуга, яка раніше стояла в шапці. Тут, поруч із числами, вона каже
		     більше, ніж четвертим рядком у ряду трирядкових пунктів. -->
		<div class="storageBar">
			<div class="storageFill" [style.width.%]="barPercent"></div>
		</div>

		<div class="stRow" *ngIf="over && s.enforcing">
			Створення нових трансляцій і завантаження призупинено. Щоб продовжити — звільніть місце або розширте тариф.
		</div>
		<div class="stRow" *ngIf="over && !s.enforcing">
			З <b>{{s.enforceFrom | date:'dd.MM.yyyy'}}</b> створити нову трансляцію чи завантажити відео можна буде лише в межах тарифу. До цієї дати все працює як раніше.
		</div>

		<div class="stRow" *ngIf="s.upgrade">
			Тариф <b>{{s.upgrade.title}}</b> — це {{s.upgrade.storageQuotaGb}} ГБ.
		</div>

		<div class="stRow" *ngIf="priceAmount">
			Додаткові терабайти оплачуються щомісяця разом із тарифом.
		</div>

		<div class="stMuted" *ngIf="s.measuredAt">Дані оновлено {{s.measuredAt | date:'dd.MM.yyyy HH:mm'}}</div>

		<div class="stAction" *ngIf="priceAmount">
			<button class="stBtn" [disabled]="buying" (click)="buy()">
				{{buying ? 'Додаємо...' : 'Додати 1 ТБ — ' + priceAmount + ' грн/міс'}}
			</button>
			<div class="stErr" *ngIf="buyError === 'not_enough'">Недостатньо коштів. Поповніть рахунок і спробуйте ще раз.</div>
			<div class="stErr" *ngIf="buyError === 'failed'">Не вдалося додати терабайт. Спробуйте ще раз.</div>
		</div>
	</div>
</ng-template>

<div class="storageBlockedNote" *ngIf="authService.storageBlocked && over && s.enforcing">
	<span>Квоту вичерпано — нові трансляції та завантаження недоступні. Звільніть місце або розширте тариф.</span>
	<button class="stBtn" *ngIf="priceAmount" [disabled]="buying" (click)="buy()">{{buying ? 'Додаємо...' : 'Додати 1 ТБ — ' + priceAmount + ' грн/міс'}}</button>
</div>

<div class="storageWarnNote" *ngIf="authService.storageWarnAfterCreate && over && !s.enforcing" (click)="authService.storageWarnAfterCreate = false">
	<span>Ви перевищили квоту тарифу ({{quotaValue}} {{quotaInTb ? 'ТБ' : 'ГБ'}}). З <b>{{s.enforceFrom | date:'dd.MM.yyyy'}}</b> створити нову трансляцію чи завантажити відео можна буде лише в межах тарифу.</span>
	<button class="stBtn" *ngIf="priceAmount" [disabled]="buying" (click)="buy(); $event.stopPropagation()">{{buying ? 'Додаємо...' : 'Додати 1 ТБ — ' + priceAmount + ' грн/міс'}}</button>
</div>
